import * as ProgressPrimitive from '@radix-ui/react-progress';

import { mergeClasses } from '@/utils';

import { IProgress } from './Progress.interfaces';

const Progress = ({ className, value, title, ...props }: IProgress) => {
  return (
    <div className={mergeClasses('w-full flex flex-col gap-2', className)}>
      <div className="flex flex-row items-center justify-between">
        <span className="text-sm font-medium text-brand-primary-darkest">{title}</span>
        <span className="text-sm font-medium text-brand-primary-darkest">{value}%</span>
      </div>
      <ProgressPrimitive.Root
        data-slot="progress"
        className="bg-neutral-n3 relative h-4 w-full overflow-hidden rounded-full"
        {...props}
      >
        <ProgressPrimitive.Indicator
          data-slot="progress-indicator"
          className="bg-brand-primary-base h-full w-full flex-1 transition-all rounded-full"
          style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
        />
      </ProgressPrimitive.Root>
    </div>
  );
};

export default Progress;
